import { createFileRoute, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { LexroomShell } from "@/components/app/lexroom-shell";

export const Route = createFileRoute("/_authenticated")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex,nofollow" },
      { name: "googlebot", content: "noindex,nofollow" },
    ],
  }),
  beforeLoad: async ({ location }) => {
    const { data } = await supabase.auth.getSession();
    if (!data.session) throw redirect({ to: "/login" });
    if (!location.pathname.startsWith("/onboarding")) {
      const { data: profile } = await supabase
        .from("profiles").select("onboarded").eq("id", data.session.user.id).maybeSingle();
      if (profile && profile.onboarded === false) throw redirect({ to: "/onboarding" });
    }
  },
  component: LexroomShell,
});
